<mat-form-field>
    <mat-label>Model</mat-label>
    <input #input type="text" matInput [required]="required" [formControl]="droneModel" [matAutocomplete]="auto"
        (input)="filter()" (focus)="filter()">
    <mat-autocomplete requireSelection #auto="matAutocomplete" [displayWith]="displayValueFunc">
        @for (droneModel of filteredModels; track droneModel) {
        <mat-option [value]="droneModel">{{droneModel.type}} - {{droneModel.description}}</mat-option>
        }
    </mat-autocomplete>
</mat-form-field>